import {Component, Prop} from 'vue-property-decorator'
import * as Vue from "vue-tsx-support";
import "vue-tsx-support/enable-check"
import './iconBtnGroup.less'
import Button from "../../types/iview/Button";
import { CommonUtil } from 'src/util/commonUtil';

export interface IconBtnItem {
	text: string
	icon?: string
	type?: 'error'|'warning'|'success'|'info'|'dashed'|'primary'
	onClick (): Promise<void>| void
	hide?: boolean
	disabled?: boolean
	loading?: boolean
}

export interface IconBtnGroupProps {
	dataSource: Array<IconBtnItem>
}

@Component
export default class IconBtnGroup extends Vue.Component<IconBtnGroupProps> {

	@Prop({
		type: Array,
		default: () => {
			return []
		}
	})
	dataSource?: Array<IconBtnItem>

	getClass (item: IconBtnItem): string {
		let classes: Array<string> = ['icon-btn']
		if (item.disabled) {
			classes.push('icon-btn-disabled')
		}
		if (item.loading) {
			classes.push('icon-btn-loading')
		}
		return classes.join(' ')
	}

	async click(item) {
		if (item.disabled) {
			return
		}
		if (item.loading === true) {
			return this.$Notice.warning({desc: '操作正在进行中，请稍等'})
		}
		this.execFn(item)
	}
	async execFn(item:IconBtnItem) {
		if (CommonUtil.isFunction(item.onClick)) {
			let res = item.onClick()
			if (res instanceof Promise) {
				item.loading = true
				this.$forceUpdate()
				await res
				item.loading = false
				this.$forceUpdate()
			}

		}
	}
	show(item) {
		let authority = this.$route.meta.authority
		if(authority && authority[item.text]===false) {
			return false
		}
		if(item.hide === false) {
			return false
		}
		return true
	}
	render (h) {
		return (
			<div class="icon-btn-group clearfix">
				{
					(this.dataSource||[]).map((item, index) => {
						// return <div v-show={this.show(item)} class={this.getClass(item)} key={index} onClick={this.click.bind(this, item)}>
						// 	<i class={`wqms-font ${item.icon}`}></i>
						// 	<div>{item.text}
						// 		<Icon type="ios-loading" class="ivu-load-loop wms-ml2" v-show={item.loading}></Icon>
						// 	</div>
						// </div>
						return <Button type={item.type||'primary'} class="wqms-mr10 wqms-operate-btn" disabled={item.disabled} loading={item.loading} onClick={this.click.bind(this, item)}>{item.text}</Button>
					})
				}
			</div>
		)
	}
}
